import './styles/main.scss'
import './styles/pages/_home.scss'
import './scripts/common'
import './scripts/nav'
import './scripts/footer'
import Tabbox from './models/Tabbox'

new Tabbox('#case-study-tabbox')
